// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__C-GhR","label":"Labeled_label__2NcDT","divider":"Labeled_divider__4dRWf"};